const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v2`;

export const FIELD_LABELS = {
  amount: 'Monto', impact_pct: 'Impacto %', category: 'Categoría', risk_level: 'Riesgo',
  module_type: 'Módulo', confidence: 'Confianza', agent_name: 'Agente',
};
export const NUMERIC_FIELDS = ['amount', 'impact_pct', 'confidence'];
export const OPERATOR_LABELS = { gt: '>', gte: '≥', lt: '<', lte: '≤', eq: '=', neq: '≠', in: 'en', contains: 'contiene' };
export const STATUS_META = {
  pending: { label: 'Pendiente', cls: 'bg-amber-100 text-amber-800' },
  approved: { label: 'Aprobada', cls: 'bg-emerald-100 text-emerald-800' },
  rejected: { label: 'Rechazada', cls: 'bg-red-100 text-red-800' },
  expired: { label: 'Expirada', cls: 'bg-slate-200 text-slate-700' },
  auto_cleared: { label: 'Sin aprobación requerida', cls: 'bg-sky-100 text-sky-800' },
  blocked: { label: 'Bloqueada', cls: 'bg-red-600 text-white' },
};

export const ACTION_META = {
  block: { label: 'Bloquear', cls: 'bg-red-600 text-white', help: 'Detiene la propuesta. Una aprobación no la desbloquea: hay que corregirla o autorizar una excepción.' },
  require_approval: { label: 'Requiere aprobación', cls: 'bg-amber-100 text-amber-800', help: 'La propuesta queda pendiente hasta completar las aprobaciones.' },
  warn: { label: 'Advertir', cls: 'bg-orange-100 text-orange-800', help: 'Sigue adelante, con una advertencia visible y registrada en la auditoría.' },
  log: { label: 'Registrar', cls: 'bg-slate-200 text-slate-700', help: 'Sigue adelante sin interrupciones; solo deja constancia en la auditoría.' },
};
export const MODE_LABELS = { single: 'Un aprobador', quorum: 'Mínimo de aprobaciones', all_named: 'Personas elegidas (todas)', sequential: 'En orden por niveles' };
export const ROLE_NAMES = { admin: 'Admin', super_admin: 'Super Admin' };

export const planSummary = (r) => {
  const role = ROLE_NAMES[r.approver_role] || r.approver_role;
  if (r.approval_mode === 'quorum') return `${r.min_approvals} aprobaciones de ${role}`;
  if (r.approval_mode === 'all_named') return `${(r.approver_user_ids || []).length} personas elegidas`;
  if (r.approval_mode === 'sequential') return (r.levels || []).map((l, i) => `N${i + 1}: ${l.min_approvals} ${ROLE_NAMES[l.role]}`).join(' → ');
  return `Aprueba: ${role}`;
};

export const AUDIT_LABELS = {
  created: 'Creada', approved: 'Aprobada', rejected: 'Rechazada', expired: 'Expirada', project_created: 'Proyecto creado',
  approval_recorded: 'Aprobación registrada', corrected: 'Corregida', exception_granted: 'Excepción autorizada',
  rule_block: 'Regla de bloqueo', rule_require_approval: 'Regla de aprobación', rule_warn: 'Advertencia', rule_log: 'Registro de regla',
};

const LEVEL_NAMES = { critica: 'Crítica', alta: 'Alta', media: 'Media', baja: 'Baja' };
export const sourceLabel = (p) => {
  const s = p.source || {};
  if (s.type === 'insight') return `Agente ${p.agent_name || ''}`;
  if (s.type === 'materiality') return `Alerta de materialidad · ${LEVEL_NAMES[s.level] || s.level || ''} · puntaje ${s.score != null ? Math.round(s.score) : '—'}`;
  return 'Manual';
};

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => String(x.msg).replace(/^Value error, /, '')).join('; ');
  return d || e?.message || 'Error inesperado';
};
